import { render, staticRenderFns } from "./portalLoadingSkeleton.vue?vue&type=template&id=df105cd8&scoped=true&lang=pug"
import script from "./portalLoadingSkeleton.vue?vue&type=script&lang=js"
export * from "./portalLoadingSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df105cd8",
  null
  
)

export default component.exports